<template>
    <div class="journey">
        <div class="container-fluid pt-3">

        <div class="page-top mb-3">
            <h1>{{ t('clients-journey-title') }}</h1>
            <button class="btn btn-warning" @click="showClientsWithoutStage">
                {{ t('clients-journey-outside_journey', [counters[0]]) }}
            </button>
        </div>
        <modal
            ref="moveStage"
            :startsOpen="false"
            id="moveStage"
            @hide="cancelMovement"
            class="modal-journey"
        >
            <template slot="title"> {{ t('clients-journey-move_to_which_stage') }} </template>
            <template slot="body">
                <div>
                    <JourneyTree @select="selectMovement">
                        <template #actions="{ node: childNode }">
                            <span
                                class="icon"
                                v-if="!Object.values(childNode.children).length"
                            >
                                <div
                                    class="far fa"
                                    :class="
                                        selected.id === childNode.id
                                            ? 'fa-check-square'
                                            : 'fa-square-o'
                                    "
                                ></div>
                            </span>
                        </template>
                    </JourneyTree>
                </div>
            </template>
            <template slot="footer">
                <div>
                    <button
                        type="button"
                        class="btn btn-cancel"
                        @click="cancelMovement"
                    >
                        {{ t('clients-modals-cancel') }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-success"
                        @click="move"
                        :disabled="!isValid || moving"
                    >
                        <span v-if="moving">
                            <i class="fa fa-spinner fa-spin"></i>
                        </span>
                        {{
                            selected.id
                                ? t('clients-journey-move_to_action', [countSelected, selected.name])
                                : t('clients-journey-move_action', [countSelected])
                        }}
                    </button>
                </div>
            </template>
        </modal>

        <div class="journey-counters">
            <JourneyTree @select="loadClients" height="calc(100vh - 150px)">
                <template v-slot:actions="{ node }" class="actions">
                    <span class="number"
                        ><small>{{ counters[node.id] || 0 }}</small></span
                    >

                    <router-link
                        :to="getBoardUrl(node)"
                        class="btn btn-sm btn-outline-success btn-board icon"
                    >
                        <div class="far fa fa-th-large"></div>
                    </router-link>
                </template>
            </JourneyTree>
        </div>
        <div ref="grid-holder">
            <div class="box clients-list mt-4" v-if="showClientsFor !== null">
                <grid
                    :source="'client-stage/' + showClientsFor.id + '/clients'"
                    :filters="filters"
                    :show-search="showSearch"
                    @loaded="loadedGrid"
                    ref="grid"
                >
                    <template v-slot:grid-header="response">
                        <div class="grid-top">
                            <h3>{{ showClientsFor.name }}</h3>
                            <button
                                :disabled="countSelected === 0"
                                @click.prevent="$refs.moveStage.open()"
                                class="btn btn-primary"
                            >
                                {{ t('clients-journey-move_action', [countSelected]) }}
                            </button>
                        </div>
                    </template>
                    <template v-slot:rows="grid">
                        <thead>
                            <tr>
                                <grid-th
                                    :grid="grid"
                                    :sortable="false"
                                    attr="client_name"
                                >
                                    <input
                                        type="checkbox"
                                        :checked="allClientsSelected"
                                        @change="toggleAll"
                                    />
                                    {{ t('clients-columns-name') }}
                                </grid-th>
                                <grid-th
                                    :grid="grid"
                                    :sortable="false"
                                    attr="whatsapp"
                                    >{{ t('clients-columns-phone') }}</grid-th
                                >
                                <grid-th
                                    :grid="grid"
                                    :sortable="false"
                                    attr="email"
                                    >{{ t('clients-columns-email') }}</grid-th
                                >
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="client in grid.data" :key="client.id">
                                <td>
                                    <input
                                        type="checkbox"
                                        v-model="selectedClients[client.id]"
                                    />
                                    {{ client.first_name }}
                                    {{ client.last_name }}
                                </td>
                                <td>{{ formatPhone(client.whatsapp) }}</td>
                                <td>{{ client.email }}</td>
                            </tr>
                        </tbody>
                    </template>
                </grid>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import JourneyTree from "./tree.vue";
import keviApi from "../../keviApi";
import Modal from "../../components/modal/modal";
import phoneMixin from "../../mixins/phone-mixin";
export default {
    mixins: [phoneMixin],
    components: { Modal, JourneyTree },
    props: {
        type: String,
    },
    data: function () {
        return {
            showClientsFor: null,
            counters: {},
            selectedClients: {},
            gridData: [],
            selected: {},
            filters: {},
            showSearch: false,
            moving: false,
        };
    },
    mounted() {
        this.loadCounters();
    },
    computed: {
        allClientsSelected() {
            return Object.values(this.selectedClients).every((value) => value);
        },
        countSelected() {
            return Object.values(this.selectedClients).filter((value) => value)
                .length;
        },
        isValid() {
            return !!this.selected?.id;
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        showClientsWithoutStage() {
            this.showClientsFor = {
                id: 0,
                name: this.t('outside_journey'),
            };
        },
        toggleAll() {
            const allClientsSelected = this.allClientsSelected;
            Object.keys(this.selectedClients).forEach((key) => {
                this.selectedClients[key] = !allClientsSelected;
            });
        },
        loadCounters() {
            let options = keviApi.getOptions("client-stages/counters", "GET");
            this.$http(options).then((response) => {
                this.counters = response.data;
            });
        },
        loadBoard(node) {
            console.log(node);
            // i18n-validator-ignore-next-line: debug alert with dynamic content
            alert("load list " + node.name);
        },
        loadClients(node) {
            this.showClientsFor = node;
        },
        round(value) {
            return Math.round(value);
        },
        loadedGrid(response) {
            this.gridData = response;
            this.selectedClients = {};
            this.gridData.data.forEach((client) => {
                this.$set(this.selectedClients, client.id, false);
            });
            this.scrollToGrid();
        },
        scrollToGrid() {
            this.$nextTick(() => {
                this.$refs["grid-holder"].scrollIntoView({
                    behavior: "smooth",
                });
            });
        },
        cancelMovement() {
            this.selected = {};
            this.$refs.moveStage.close();
        },
        move() {
            if (this.selected && this.selected.id) {
                let options = keviApi.getOptions(
                    "client-stage/" + this.selected.id + "/move",
                    "POST",
                    {
                        clients: Object.keys(this.selectedClients).filter(
                            (key) => this.selectedClients[key],
                        ),
                    },
                );
                this.moving = true;
                this.$http(options).then((response) => {
                    this.$refs.moveStage.close();
                    this.loadCounters();
                    this.$store.dispatch(
                        "notification/success",
                        this.t('clients-journey-move_completed_success'),
                    );
                    this.$refs.grid.update();
                    this.moving = false;
                });
            }
        },
        selectMovement(node) {
            if (Object.values(node.children).length === 0) {
                this.selected = node;
            }
        },
        getBoardUrl(node) {
            if (node.parent_clients_stages_id) {
                return `/clients/journey/board/${node.parent_clients_stages_id}/${node.id}`;
            }
            return `/clients/journey/board/${node.id}`;
        },
    },
};
</script>
<style>
.page-content.clients-journey {
    max-width: 100%;
    padding-bottom: 0;
    overflow: hidden;
}
</style>
<style lang="scss" scoped>
.grid-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    h3,
    button {
        margin: 0;
    }
}

.btn-board {
    padding: 0;
    border: none;
    font-size: 14px;
    margin: 0;
}
.variant-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
}

.page-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    h1,
    button {
        margin: 0 0 0 0;
    }
}
::v-deep {
    .modal-journey {
        .node-parent {
            > .node-header {
                cursor: default;
                opacity: 0.4;
            }
        }
        .modal-dialog {
            max-width: 90vw;
            height: 90vh;
        }
        .modal-body {
            height: calc(100vh - 250px);
            max-height: calc(100vh - 250px);
            > div {
                height: 100%;
                > form {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    .automation-action-settings {
                        flex-grow: 1;
                        overflow: auto;
                    }
                }
            }
        }
    }
    .journey-counters {
        .node-header {
            .actions {
                position: relative;
            }
            .number {
                visibility: visible;
                opacity: 1;
                transition: all 0.3s;
                position: absolute;
            }
            .icon {
                visibility: hidden;
                opacity: 0;
                transition: all 0.3s;
            }
            &:hover {
                .number {
                    visibility: hidden;
                    opacity: 0;
                }
                .icon {
                    visibility: visible;
                    opacity: 1;
                    &:hover {
                        transform: scale(1.3);
                        transform-origin: center;
                    }
                }
            }
        }
    }
}
</style>
